import { render, staticRenderFns } from "./DataTrade.vue?vue&type=template&id=14b0cbab&"
import script from "./DataTrade.vue?vue&type=script&lang=js&"
export * from "./DataTrade.vue?vue&type=script&lang=js&"
import style0 from "./DataTrade.vue?vue&type=style&index=0&id=14b0cbab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports